import Modal from "../../components/Modal/Modal";
import CadastroProcesso from "../Processos/CadastroProcesso";

type ModalConsulProcessProps = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}
export default function ModalConsultProcesso({ open, setOpen }: ModalConsulProcessProps) {
    function handleClose() {
        setOpen(false);
    }
    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="DADOS PROCESSO"
            maxWidth="lg"
            zIndex={8888}
        >
            <CadastroProcesso exe={handleClose} />
        </Modal>
    );
}